import { Modal } from 'react-bootstrap';
import moment from 'moment';
import CurrencyFormat from 'react-currency-format';

const InvoicePaymentHistoryModal = (props) => {

    return (
    <div>
        <Modal show={props.show} onHide={props.handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Invoice Payment History ({props.invoiceNumber})</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='row'>
                    <div className="col-md-12">
                        {(props.paymentHistory)?.length > 0 && (
                            <table className="table table-bordered" id="client_id_table" key='student-subject-history'>
                                <tbody>
                                    <tr className='text-center'>
                                        <th>Payable Amount</th>
                                        <th>Amount Paid</th>
                                        <th>Outstanding Amount</th>
                                        <th>Comment</th>
                                        <th>Paid Date</th>
                                    </tr>
                                    {(props.paymentHistory)?.length > 0  && (props.paymentHistory).map((obj, i) => (
                                        <tr key={obj.id + '-' + i} className='text-center'>
                                            <td><CurrencyFormat value={ obj?.total_payable_amount } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={props?.currency + ' '} /> </td>
                                            <td><CurrencyFormat value={ obj?.amount_paid } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={props?.currency + ' '} /> </td>
                                            <td><CurrencyFormat value={ obj?.amount_outstanding } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={props?.currency + ' '} /> </td>
                                            <td>{ obj?.comment ?? '---'}</td>
                                            <td>{ (obj.created_at != null) ? moment(obj.created_at).format('DD/MM/YYYY HH:mm') : 'N/A'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                        {(props.paymentHistory)?.length == 0 && (
                            <span style={{ color: "red", textAlign: "center" }}>There are no records to display</span>
                        )}
                    </div>
                </div>
            </Modal.Body>
            {/* <Modal.Footer>
                <Button className='btn btn-default' onClick={props.handleClose}>Close</Button>
            </Modal.Footer> */}
        </Modal>
    </div>
  )
}

export default InvoicePaymentHistoryModal;